module.exports = __webpack_public_path__ + "img/Sokal-Toyota-SRS-112221-Modern.4d8c3790.jpeg";